export default {
      id: "graph-tresca-usage",
      viewBox: "0 0 155 161",
      url: __webpack_public_path__ + "svg/sprite.svg#graph-tresca",
      toString: function () {
        return this.url;
      }
    }